import React from 'react'
import styled from 'styled-components'
import { Typography } from '@material-ui/core'
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery'
import bg_lines from '../assets/images/bg_lines.svg'
import FormLogin from '../components/login/FormLogin';
const useStyles = makeStyles(theme => ({
    root: {
      '& > * + *': {
        marginLeft: theme.spacing(2),
      },
    },
    footer_text: {
        color: '#BCBCCB',
        fontSize: '10px',
        letterSpacing: 0,
        padding: '0 55px',
        lineHeight: 1.2,
        margin: '40px 0 24px'
    },
    login_link: {
        marginTop: '8px'
    }
}));
const Content = styled.div`
    width: 100%;
    min-height: 100vh;
    display: flex;
`
const GradientBlock = styled.div`
    width: 50%;
    background-image: url(${ bg_lines }), linear-gradient(60deg, #cd103a, #4212e3);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: bottom , center;
`
const FormBlock = styled.div`
    width: ${({ breakpoint }) => (breakpoint ? '50%' : '100%')};
    display: flex;
    justify-content: center;
    align-items: flex-end;
    flex-wrap: wrap;
    text-align: center;
`
const FooterContent = styled.div`
    flex-basis: 100%;
    display: flex;
    flex-direction: column;
`
const Login = () => {
    const classes = useStyles();
    const isDefaultBreakpoint = useMediaQuery('(min-width:1050px)')
    return (
        <Content>
            {isDefaultBreakpoint ? <GradientBlock/> : ''}
            <FormBlock breakpoint={isDefaultBreakpoint}>
                <FormLogin />
                <FooterContent>
                    <Typography variant="body2" style={{ color: '#43425D' }}>Termos de uso. Política de privacidade</Typography>
                    <Typography variant="body2" className={classes.login_link}>
                        <Link href="https://atendimento.manole.com.br/aprimora/central-atendimento/" rel="noopener" target="_blank">Central de Atendimento</Link>
                    </Typography>
                    <Typography variant="caption" display="block" className={classes.footer_text}>
                        A Editora Manole é líder em prover conteúdo essencial à formação do estudante, 
                        do profissional nas áreas científicas, técnicas e profissionais. 
                        Seu catálogo, com mais de mil títulos de autores nacionais e estrangeiros,
                        preza pela excelência gráfica e editorial, 
                        buscando oferecer ao leitor o melhor da produção acadêmica brasileira e mundial. 
                        Há mais de 50 anos no mercado, a Manole segue inovando
                    </Typography>
                </FooterContent>
            </FormBlock>
        </Content>
    )
}
export default Login